import { render, staticRenderFns } from "./detail-tips.vue?vue&type=template&id=53a1dadb&scoped=true"
import script from "./detail-tips.vue?vue&type=script&lang=js"
export * from "./detail-tips.vue?vue&type=script&lang=js"
import style0 from "./detail-tips.vue?vue&type=style&index=0&id=53a1dadb&prod&scoped=true&lang=css"
import style1 from "./detail-tips.vue?vue&type=style&index=1&id=53a1dadb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a1dadb",
  null
  
)

export default component.exports